import React from "react";
import "./KycForm.scss";
import {MDBIcon} from "mdbreact";
import cogoToast from "cogo-toast";
import KycUpdateMutation from "../../mutations/KycUpdateMutation";
import {withRouter} from "react-router-dom";
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";

class KycForm extends React.Component {
	state = {
		activeTab: "upi",
		vpa: "",
		save_info: false,
		accNum: "",
		bankName: "",
		beneficiaryName: "",
		email: "",
		ifscCode: "",
		loading: false
	}
	handleTabToggle = (tag) => {
		this.setState({
			activeTab: tag
		})
	}
	handleInputChanges = (e, feild) => {
		this.setState({
			[feild]: e.target.value
		});
	}
	handleSubmit = () => {
		let variable = {}
		if (this.state.activeTab === "upi") {
			variable = {
				upiId: this.state.vpa,
				accType: "VPA",
				beneficiaryName: this.state.beneficiaryName,
			}
			if (this.validateUpi()) {
				this.updateKycForm(variable);
			}
		} else if (this.state.activeTab === "bank") {
			variable = {
				accNum: this.state.accNum,
				accType: "Bank_Acc",
				bankName: this.state.bankName,
				beneficiaryName: this.state.beneficiaryName,
				email: this.state.email,
				ifscCode: this.state.ifscCode,
			}

			this.updateKycForm(variable);

		}
	}

	validateUpi() {
		let form_valid = false;
		if (this.state.vpa !== "" && /^\w.+@\w+$/.test(this.state.vpa)) {
			form_valid = true;
		} else {
			form_valid = false;
			cogoToast.error("Please fill valid VPA ID", {position: 'top-center'});
		}
		return form_valid;
	}

	validateBankForm = () => {
		let form_valid = false;
		if (this.state.bankName === "") {
			form_valid = false;
			cogoToast.error("Please fill valid bank name", {position: 'top-center'});
		} else if (this.state.accNum === "") {
			form_valid = false;
			cogoToast.error("Please fill valid account number", {position: 'top-center'});
		} else if (this.state.ifscCode === "") {
			form_valid = false;
			cogoToast.error("Please fill valid ifscCode", {position: 'top-center'});
		} else if (this.state.beneficiaryName === "") {
			form_valid = false;
			cogoToast.error("Please fill valid beneficiary Name", {position: 'top-center'});
		} else if (this.state.email === "") {
			form_valid = false;
			cogoToast.error("Please fill valid email", {position: 'top-center'});
		} else {
			form_valid = true;
		}
		return form_valid;
	}

	updateKycForm = (variable) => {
		this.setState({
			loading: true
		});
		let scope = this;
		KycUpdateMutation(variable, function (response) {
			scope.setState({
				loading: false
			});
			if (response.kycUpdate !== null && response.kycUpdate.kyc !== null) {
				scope.props.history.push("/wallet");
				cogoToast.success(response.kycUpdate.message, {position: 'top-center'});
			}
		}, function (err) {
			scope.setState({
				loading: false
			});
			cogoToast.error(err, {position: 'top-center'});
		});
	}

	render() {
		const {activeTab} = this.state;
		return (
			<div className={"kyc-form-component py-2"}>
				{/*<MDBContainer>*/}
				<TopNavSubpage heading={"Add Account"} notify={true} wallet={false}/>
				{/*</MDBContainer>*/}

				<div className={' pb-3'}>
					<div className={"wallet-history-tab-main d-flex"}>
						<div onClick={() => this.handleTabToggle("upi")}
						     className={activeTab === "upi" ? "wallet-history-tabWrap-active mx-4 " : "wallet-history-tabWrap mx-4 "}>
							<p className={"wallet-history-tab-text mb-3 mr-1 "}>UPI ID</p>
							<hr className={"wallet-history-tab-underline mt-0 mb-1"}/>
						</div>
						<div onClick={() => this.handleTabToggle("bank")}
						     className={activeTab === "bank" ? "wallet-history-tabWrap-active ml-4 " : "wallet-history-tabWrap ml-4 "}>
							<p className={"wallet-history-tab-text mb-3 mr-1"}>Bank A/C</p>
							<hr className={"wallet-history-tab-underline mt-0 mb-1"}/>
						</div>
					</div>
				</div>

				<div className={"kyc-form-section px-4 pt-1"}>
					{
						this.state.activeTab === "upi" &&
						<div>
							<form>
								<label htmlFor="defaultFormLoginEmailEx" className="form-label">
									VPA (UPI ID)
								</label>
								<input type="text"
								       id="defaultFormLoginEmailEx"
								       className="form-control form-input"
								       value={this.state.vpa}
								       placeholder={"upi@service"}
								       onChange={(e) => this.handleInputChanges(e, "vpa")}
								/>
								<br/>
								<label htmlFor="defaultFormLoginEmailEx" className="form-label">
									Beneficiary Name
								</label>
								<input type="text"
								       id="defaultFormLoginEmailEx"
								       className="form-control form-input"
								       value={this.state.beneficiaryName}
								       placeholder={"Name of the person"}
								       onChange={(e) => this.handleInputChanges(e, "beneficiaryName")}
								/>
							</form>
						</div>
					}
					{
						this.state.activeTab === "bank" &&
						<div>
							<form>
								<label htmlFor="defaultFormLoginEmailEx" className="form-label">
									Bank Name
								</label>
								<input type="text"
								       id="defaultFormLoginEmailEx"
								       className="form-control form-input"
								       value={this.state.bankName}
								       placeholder={"Enter bank name"}
								       onChange={(e) => this.handleInputChanges(e, "bankName")}
								/>
								<br/>
								<label htmlFor="defaultFormLoginEmailEx" className="form-label">
									Account Number
								</label>
								<input type="number"
								       id="defaultFormLoginEmailEx"
								       className="form-control form-input"
								       value={this.state.accNum}
								       placeholder={"Enter account number"}
								       onChange={(e) => this.handleInputChanges(e, "accNum")}
								/>
								<br/>
								<label htmlFor="defaultFormLoginEmailEx" className="form-label">
									IFSC
								</label>
								<input type="text"
								       id="defaultFormLoginEmailEx"
								       className="form-control form-input"
								       value={this.state.ifscCode}
								       placeholder={"IFSC of the bank account"}
								       onChange={(e) => this.handleInputChanges(e, "ifscCode")}
								/>
								<br/>
								<label htmlFor="defaultFormLoginEmailEx" className="form-label">
									Beneficiary Name
								</label>
								<input type="text"
								       id="defaultFormLoginEmailEx"
								       className="form-control form-input"
								       value={this.state.beneficiaryName}
								       placeholder={"Name of the person"}
								       onChange={(e) => this.handleInputChanges(e, "beneficiaryName")}
								/>
								<br/>
								<label htmlFor="defaultFormLoginEmailEx" className="form-label">
									Email
								</label>
								<input type="email"
								       id="defaultFormLoginEmailEx"
								       className="form-control form-input"
								       value={this.state.email}
								       placeholder={"Enter email id"}
								       onChange={(e) => this.handleInputChanges(e, "email")}
								/>
								<br/>
							</form>
						</div>
					}

					<div>
						<div className={"d-flex save-info-section"}>
							<div className="custom-checkbox-section">
								<form>
									<div className="form-group">
										<input type="checkbox" id="html"/>
										<label htmlFor="html"/>
									</div>
								</form>
							</div>
							<p className={"mb-0 ml-2 description"}>Do you want to save the above information for
								future transactions?</p>
						</div>
						<button type={"button"} className={"btn submit-btn"}
						        onClick={this.handleSubmit}
						        disabled={this.state.loading}
						>
							Submit
							<MDBIcon icon="angle-right" className={"mx-2"}/>
						</button>
					</div>

				</div>
			</div>
		);
	}
}

export default withRouter(KycForm);